import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  getHoldingWithApartmentSchemaWithAdditionalFields,
  holdingWithApartmentSchema,
} from "./holding-with-apartment";
import {
  getLeaseWithApartmentSchemaWithAdditionalFields,
  leaseWithApartmentSchema,
} from "./lease-with-apartment";
import { getPersonSchemaAdditionalFields, personSchema } from "./person";
import {
  getSubletWithApartmentSchemaWithAdditionalFields,
  subletWithHoldingOrLeaseAndApartmentSchema,
} from "./sublet-with-holding-or-lease-and-apartment";

export const personWithHoldingsAndLeasesAndSubletsAndApartmentSchema =
  personSchema.extend({
    holdings: z.array(holdingWithApartmentSchema),
    leases: z.array(leaseWithApartmentSchema),
    sublets: z.array(subletWithHoldingOrLeaseAndApartmentSchema),
    issueCount: z.number().int().nonnegative().default(0),
  });

export type PersonWithHoldingsAndLeasesAndSubletsAndApartment = z.infer<
  typeof personWithHoldingsAndLeasesAndSubletsAndApartmentSchema
>;

export function getPersonWithHoldingsAndLeasesAndSubletsAndApartmentSchemaWithAdditionalFields(additionalFields: {
  person: typeof additionalDataSchema;
  holding: typeof additionalDataSchema;
  lease: typeof additionalDataSchema;
  sublet: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
  apartment: typeof additionalDataSchema;
}): typeof personWithHoldingsAndLeasesAndSubletsAndApartmentSchema {
  return getPersonSchemaAdditionalFields(additionalFields)
    .merge(personWithHoldingsAndLeasesAndSubletsAndApartmentSchema)
    .extend({
      holdings: z.array(
        getHoldingWithApartmentSchemaWithAdditionalFields(additionalFields),
      ),
      leases: z.array(
        getLeaseWithApartmentSchemaWithAdditionalFields(additionalFields),
      ),
      sublets: z.array(
        getSubletWithApartmentSchemaWithAdditionalFields(additionalFields),
      ),
    });
}
